<div class="container">
  <div class="col-md-12 mb-5 empl-tptxt">
    <h3>Query Stats Summary</h3>
  </div>
  <div class="row py-3 mx-0 align-items-center">
    <div class="col-md-6 col-12 px-0"></div>
    <div class="col-md-6 col-12 px-0">
      <div class="row justify-content-end">
        <div class="col-md-6 col-6">
          <div class="row mx-0">
            <div class="col-md-3 align-self-center px-0 text-md-center">
              <p class="mb-0">From</p>
            </div>
            <div class="col-md-9 align-self-center px-0 text-center">
              <input type="date" class="form-control" [(ngModel)]="fromDate" (change)="dateSelection()" />
            </div>
          </div>
        </div>
        <div class="col-md-6 col-6">
          <div class="row mx-0">
            <div class="col-md-3 align-self-center px-0 text-md-center">
              <p class="mb-0">To</p>
            </div>
            <div class="col-md-9 align-self-center px-0 text-center">
              <input type="date" class="form-control" [(ngModel)]="toDate" (change)="dateSelection()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row">
      <app-summary-data-table *ngIf="isVisible" [options]="summaryOptions" [data]="summaryData" />
    </div>
  </div>
  <br />
</div>
